var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35961 5.10961C10.0696 4.00961 11.3096 3.28961 12.7096 3.28961C14.9196 3.28961 16.7096 5.07961 16.7096 7.28961C16.7096 8.68961 15.9896 9.92961 14.8896 10.6396L9.35961 5.10961ZM20.7096 16.4596C20.6896 15.3596 20.0796 14.3496 19.0996 13.8396C18.5596 13.5596 17.9696 13.2996 17.3296 13.0796L20.7096 16.4596ZM21.8996 20.4796L3.51961 2.09961L2.09961 3.50961L10.9896 12.3996C9.17961 12.6296 7.59961 13.1896 6.31961 13.8496C5.31961 14.3596 4.70961 15.3896 4.70961 16.5096V19.2896H17.8796L20.4896 21.8996L21.8996 20.4796Z",
    fill: "#E51635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivate);
export default __webpack_public_path__ + "static/media/deactivate.6bbaf28a7ce980f0d363336d3af9aa44.svg";
export { ForwardRef as ReactComponent };